const util = {
	splitString: function(string, size) {
		var re = new RegExp('.{1,' + size + '}', 'g');
		return string.match(re);
	},

	play_response(update_id, idx, cb) {
		let url = `${process.env.PUBLIC_URL}/media/update${update_id}/r${idx}.m4a`
		console.log(url)
        let audio = new Audio(url);
        audio.play();
        if (cb != null) audio.onended = () => {
        	cb()
        }
    },

    play_ring() {
    	let a = new Audio(`${process.env.PUBLIC_URL}/media/call.m4a`)
    	a.play()
    }
}

export default util


// WEBPACK FOOTER //
// ./src/utils/util.js